"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var react_router_1 = require("react-router");
var carDetailsStyles_1 = require("./carDetailsStyles");
var SectionExtender_1 = require("../../sectionExtender/SectionExtender");
var CarImage_1 = require("../../../../../common/components/carDetails/CarImage/CarImage");
var CarDetailsPrices_1 = require("../CarDetailsPrices/CarDetailsPrices");
var CarImageWithBg_1 = require("../CarImage/CarImageWithBg");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var CarTitle_1 = require("../CarTitle/CarTitle");
var ButtonWithArrow_1 = require("../../../../../../common/components/presentation/Buttons/ButtonWithArrow");
var collectedFilters_1 = require("../../../../../../common/service/collectedFilters");
var useWidgetContext_1 = require("../../../../../../common/react/useWidgetContext");
var usePlatformConfig_1 = require("../../../../../../common/react/usePlatformConfig");
var Routes_1 = require("../../../../../../common/enum/Routes");
var useFinanceApplication_1 = require("../../../../../common/hooks/mutations/useFinanceApplication");
var CarDetails = function (_a) {
    var vehicleDisplayName = _a.vehicleDisplayName, imageSrc = _a.imageSrc, _b = _a.prices, primaryTotal = _b.primaryTotal, secondaryTotal = _b.secondaryTotal, isMultiCurrency = _b.isMultiCurrency, financeDetails = _a.financeDetails, isExtendable = _a.isExtendable, isExtended = _a.isExtended, toggleCarSection = _a.toggleCarSection, interiorImg = _a.interiorImg, taxLabel = _a.taxLabel;
    var style = carDetailsStyles_1.default();
    var pathname = react_router_1.useLocation().pathname;
    var isFromAltSpc = core_1.useTheme().checkoutLite.isFromAltSpc;
    var isFinanceApplicationEnabled = usePlatformConfig_1.default().platformConfig.platformFeatures.isFinanceApplicationEnabled;
    var financeApplicationUrl = useWidgetContext_1.default().configuration.financeApplicationUrl;
    var token = collectedFilters_1.default().filters.token;
    var _c = useFinanceApplication_1.useFinanceApplication(token), initFinanceApplication = _c.initFinanceApplication, loading = _c.loading;
    var confirmationRouteMatch = react_router_1.matchPath(pathname, {
        path: [Routes_1.Routes.CONFIRMATION_REQUEST_QUOTE, Routes_1.Routes.CONFIRMATION_RESERVE_ONLINE],
    });
    var showFinanceApplicationButton = !!confirmationRouteMatch && financeDetails && isFinanceApplicationEnabled && financeApplicationUrl;
    return (<core_1.Box className={style.carDetailsWrapper} data-test="summary:container:car_details">
      <core_1.Box className={style.carTitleImageContainer}>
        {isFromAltSpc ? (<>
            <CarImageWithBg_1.default imageSrc={imageSrc} interiorImg={interiorImg}/>
            <CarTitle_1.default vehicleDisplayName={vehicleDisplayName}/>
          </>) : (<>
            <CarTitle_1.default vehicleDisplayName={vehicleDisplayName}/>
            <CarImage_1.default imageSrc={imageSrc}/>
            {showFinanceApplicationButton && (<ButtonWithArrow_1.default style={{ position: 'absolute', minWidth: 240 }} className={style.financeApplicationButton} onClick={initFinanceApplication} data-test="summary:button:finance_application" disabled={loading}>
                <core_1.Typography component="span">
                  <Translation_1.default id={'trans__fincalc__apply_for_credit_CTA'}/>
                </core_1.Typography>
              </ButtonWithArrow_1.default>)}
          </>)}
      </core_1.Box>
      <CarDetailsPrices_1.default primary={primaryTotal} secondary={secondaryTotal} isMultiCurrency={isMultiCurrency} financeDetails={financeDetails} taxLabel={taxLabel}/>
      {isExtendable && (<SectionExtender_1.default text={<Translation_1.default id={"trans__checkout__vehicle_details__" + (isExtended ? 'hide' : 'view') + "_details"}/>} onClick={toggleCarSection} isSectionExtended={isExtended} data-test="summary:button:section_extender"/>)}
    </core_1.Box>);
};
exports.default = CarDetails;
